import { useTranslation } from 'next-i18next';

import { Button } from '@phoenix/design-system/frontend/ui/button/button';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { PhoenixImage } from '@phoenix/core/frontend/shared/ui/assets/phoenix-image';
import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';

import { useHeroImage } from './use-hero-image';
import { ProductStage } from './product-stage';
import { PersonalSalutation } from './personal-salutation';

const plusIcon = getDesignSystemIcon('icon-plus-16.svg');

export const DashboardHero = () => {
  const heroImage = useHeroImage();
  const { t } = useTranslation();

  const addToolButton = (containerClassName = '') => (
    <Button
      as="a"
      href={link(`/tool-shed/add-tool`)}
      className="w-full"
      btnType="white_default"
      icon={plusIcon}
      iconPosition="left"
      data-testid="addToolBtn"
      containerClassName={containerClassName}
    >
      {t('dashboard_tool_overview_button_addTool')}
    </Button>
  );

  return (
    <section
      aria-labelledby="page-title"
      className="relative overflow-hidden bg-green pt-8 pb-24 tablet:pb-[27px] desktop:pb-32"
      data-testid="heroSection"
    >
      {heroImage && (
        <PhoenixImage
          src={heroImage.fileName}
          priority={true}
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          staticTags={['imagesDashboard']}
          aria-hidden="true"
          role="presentation"
        />
      )}
      <div className="relative m-auto flex max-w-xl desktop:max-w-[1270px] flex-col items-start justify-between gap-6 px-6 tablet:flex-row">
        <PersonalSalutation>{addToolButton('desktop:hidden')}</PersonalSalutation>
        {addToolButton('shadow-lg hidden desktop:block')}
      </div>
      <div className="m-auto max-w-xl desktop:max-w-[1400px]">
        <ProductStage
          className="mt-[36px] tablet:mt-[97px] desktop:mt-[64px]"
          darkMode={heroImage?.contentfulMetadata?.tags.some(({ id }) => id === 'dark')}
        />
      </div>
    </section>
  );
};
